import { App } from 'antd';

/**
 * Returns UI common feedback mechanisms
 * @returns {import('antd/es/app/context').useAppProps}
 */
export function useFeedback() {
  return App.useApp()
}
